
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-integrations/mcp",
      function () {
        return require("private-next-pages/ai-integrations/mcp.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-integrations/mcp"])
      });
    }
  